import type { ReactNode } from "react";
import { forwardRef } from "react";
import classNames from "classnames";

export interface InputWrapperProps {
  children: ReactNode;
  className?: string;
  isError?: boolean;
}

export const InputWrapper = forwardRef<HTMLDivElement, InputWrapperProps>(
  ({ children, className, isError }, ref) => (
    <div
      ref={ref}
      className={classNames(
        "focus-within:border-light bg-primary text-dark relative block w-full appearance-none rounded-lg border transition-all",
        {
          "border-feedback-error": isError,
          "border-primary": !isError,
        },
        className,
      )}
    >
      {children}
    </div>
  ),
);

InputWrapper.displayName = "InputWrapper";
